import React from 'react';
import { useHubspotForm } from "@aaronhayes/react-use-hubspot-form";
import { ContactForm } from '../styles/common-styles';
import Head from 'next/head';
import locationImage from "../public/images/location.svg";
import phoneImage from "../public/images/phone.svg";
import stopwatchImage from "../public/images/stopwatch.svg";
import { PrimeWhite } from '../utils/constants';
import GarageMap from '../components/google-map/google-map';

function ContactUsForm() {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId: '8798012',
        formId: '5efdf3f3-7022-416b-862e-72e82c0a5d27',
        target: '#my-hubspot-form'
    });
    return (
        <div>
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care - Contact Us: Reach Out for Expert Auto Assistance" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/contactus.html" hrefLang="en" />
            </Head>
            <ContactForm>
                <div className='contact top-banner'>
                    <div className='caption text-center'>
                        <h1>We’re Here To Help</h1>
                        <h3 className='fw-normal'>Reach Out To The Experts In Car Care</h3>
                    </div>
                </div>
                <section className="feature-services abt-services py-3 py-md-5 ">
                    <div className="container">
                        <GarageMap height={400} />
                        {/* <div className="row justify-content-center">
                            <div className="item divider position-relative col-12 pb-4 pb-md-0 col-md-4 col-lg-3 pb-lg-0 mt-4">
                                <div className="item-inner text-center">
                                    <img className="mb-3" src={locationImage.src} alt="" />
                                    <h5>Address #1</h5>
                                    <div className="text-primary">716 S Frio St #110 <br/>San Antonio, TX 78207</div>
                                
                                </div>
                            </div>
                            <div className="item divider position-relative col-12 pb-4 pb-md-0 col-md-4 col-lg-3 pb-lg-0 mt-4">
                                <div className="item-inner text-center">
                                    <img className="mb-3" src={locationImage.src} alt="" />
                                    <h5>Address #2</h5>
                                    <div className="text-primary">13943 Toepperwein Rd <br/>San Antonio, TX 78233</div>
                                
                                </div>
                            </div>
                            <div className="item divider position-relative col-12 pb-4 pb-md-0 col-md-4 col-lg-3 pb-lg-0 mt-4">
                                <div className="item-inner text-center ">
                                    <img className="mb-3" src={phoneImage.src} alt="" />
                                    <h5>Phone</h5>
                                    <div className="text-primary">(210) 940-1181</div>
                                
                                </div>
                            </div>
                            <div className="item position-relative col-12 pb-4 pb-md-0 col-md-4 col-lg-3 pb-lg-0 mt-4">
                                <div className="item-inner text-center">
                                    <img className="mb-3" src={stopwatchImage.src} alt="" />
                                    <h5>Office Hours</h5>
                                    <div className="text-primary">Monday-Friday: 9am to 5pm <br/>Saturday : 9am to 1pm <br/> Sunday: Closed</div>
                                    
                                </div>
                            </div>
                        </div> */}
                    </div>
                </section>
                <div className="py-5 bg-danger themed-bg justify-content-center px-5" style={{ minHeight: 200 }}>
                    <div className="col-lg-12" style={{paddingRight: 10}}>
                        <h2 className="bold text-white fs-2" >Contact Us</h2>
                        <p className='text-white'>
                            Whether you have questions or you would just like to say hello.
                        </p>
                    </div>
                    <div className="col-lg-12" style={{backgroundColor: PrimeWhite, padding: 20, borderRadius: 10}}>
                        <div id="my-hubspot-form"></div>
                    </div>
                </div>
            </ContactForm>
        </div>
    )
}

export default ContactUsForm